import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {SearchInputComponent} from './search-input.component';
import {TooltipPanelModule} from '../tooltip-panel/tooltip-panel.module';
import {MatIconModule} from '@angular/material/icon';
import {ButtonModule} from '../button/button.module';

@NgModule({
  declarations: [SearchInputComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TooltipPanelModule,
    MatIconModule,
    ButtonModule,
  ],
  exports: [SearchInputComponent],
})
export class SearchInputModule {}
